import React, { useState, useEffect } from "react";
import Table from "components/Table";
import PropTypes from "prop-types";

import eightAxios from "configs/axiosConfig";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useHistory } from "react-router-dom";
import BlockIcon from "@material-ui/icons/Block";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import Modal from "components/Modal";
import { TextField, Grid, Typography } from "@material-ui/core";
import Filter from "components/Filter";
import {
  BLOCK_FETCH_URL,
  DIVISION_FETCH_URL,
  ESTATE_FETCH_URL,
  REGION_FETCH_URL,
  ROLES_URL,
  STORAGE_CONSTANT,
  ZONE_FETCH_URL,
} from "configs/constants";
import { getAssignedModule } from "utils/index";

import { useNotifyContext } from "@Components/Notify";
import { useTranslation } from "react-i18next";
import { COMPANY_FETCH_URL } from "configs/constants";

const model = [
  { id: "employee_id", label: "Employee ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "role", label: "Role", type: "string" },
  { id: "id_number", label: "ID Number", type: "string" },
  { id: "designation", label: "Designation", type: "string" },
  { id: "estate_name", label: "Estate Name", type: "string" },
  { id: "created_at", label: "Created Date", type: "string" },
  { id: "created_by", label: "Created By", type: "string" },
];
const urls = {
  proxyURL: "new-user/pending-users/",
  exportURL: "new-user/pending-user/export/",
  approveURL: "new-user/{id}/approve-pending-user/",
  declineURL: "new-user/{id}/decline-pending-user/",
  batchDecline: "new-user/decline-pending-users/",
  batchApprove: "new-user/approve-pending-users/",
};

const RemarkBody = ({ setRemarks, errorMessage, text, batch }) => {
  const remarksHandler = (event) => {
    event.preventDefault();
    setRemarks(event.target.value);
  };

  

  const { t } = useTranslation();

  return (
    <Grid container direction="column" spacing={2} style={{ padding: "10px" }}>
      <Grid item>
        {text ? (
          <TextField
            variant="outlined"
            name="description"
            fullWidth
            multiline
            rows={3}
            inputProps={{ maxLength: 50 }}
            onChange={remarksHandler}
          />
        ) : (
          <Typography variant="body1" color="textPrimary">
            {batch
              ? t("Are you sure you want to approve selected users?")
              : t("Are you sure you want to approve this user?")}
          </Typography>
        )}
        <Grid item justify="center">
          {errorMessage ? (
            <p style={{ textAlign: "center", color: "red" }}>{errorMessage}</p>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
};
RemarkBody.propTypes = {
  setRemarks: PropTypes.func,
  errorMessage: PropTypes.string,
  text: PropTypes.bool,
  batch: PropTypes.bool,
};

const PendingApprovalList = () => {
  const [selected, setSelected] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);

  // const [stateToRefresh, setStateToRefresh] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [filterValues, setFilterValues] = useState({});
  const history = useHistory();
  const [disableZone, setDisableZone] = useState(true);


  const [modalFields, setModalFields] = useState({
    id: null,
    batch: false,
    title: "Add Remarks",
    isOpen: false,
    body: null,
    confirmButtonLabel: "Reject User/s",
    onConfirm: null,
    decline: false,
    resetModalBodyState: () => setErrorMessage(""),
  });
  const pageNumberDropdown = true;

  const setNotify = useNotifyContext();
  const getZoneValues = (e,setDisableRegion) => {
    if (!e || e.length === 0) {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }
    
  };
  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };
  const getRegionValues = (e,setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }
    
  };

  const getEstateValues = (e,setDisableDivision) => {
    if (!e || e.length === 0) {
      setDisableDivision(true);
    }
    else {
      setDisableDivision(false);
    }
    
  };
  const getDivisonValues = (e,setDisableBlock) => {
    if (!e || e.length === 0) {
      setDisableBlock(true);
    }
    else {
      setDisableBlock(false);
    }
    
  };
  const actionBarButtons = [
    {
      color: "primary",
      buttonLabel: "Approve",
      onClick: () => {
        if (selected.length === 0) {
          setNotify({
            isOpen: true,
            message: "Please select one or more users",
            type: "error",
          });
        } else {
          approveWorker(null, true);
        }
      },
    },
    {
      color: "primary",
      buttonLabel: "Reject",
      onClick: () => {
        if (selected.length === 0) {
          setNotify({
            isOpen: true,
            message: "Please select one or more users",
            type: "error",
          });
        } else {
          declineWorker(null, true);
        }
      },
    },
  ];

  const filterFields = [
    {
      type: "input",
      name: "employee_id",
      label: "Employee ID",
    },
    {
      type: "input",
      label: "Name",
      name: "name",
    },
    {
      type: "input",
      label: "Mobile Number",
      name: "mobile_number",
    },
    {
      type: "input",
      label: "ID Number",
      name: "id_number",
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
  
  
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      disabled:disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,

      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,

      paginated: true,
      disabled:disableEstate,
      getValue: (e) => getEstateValues(e, setDisableDivision),

      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      disabled:disableDivision,
      getValue: (e) => getDivisonValues(e, setDisableBlock),

      optionsDependsOn: "estate",
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      disabled:disableBlock,

      optionsDependsOn: "division",
    },
    {
      type: "reactselect",
      name: "role",
      label: "Role",
      proxyUrl: ROLES_URL,
      paginated: false,
      isPaginationEnabled: false,
        },
  ];

  const filterInitialValues = {
    status: "",
    employee_id: "",
    name: "",
    mobile_number: "",
    id_number: "",
    company: "",
    zone: "",
    region: "",
    estate: "",
    division: "",
    role: "",
    block: "",
  };
  const approveWorker = (id = null, batch = false) => {
    if (id) {
      setModalFields({
        ...modalFields,
        id: id,
        batch: batch,
        title: "Approve User?",
        isOpen: true,
        decline: false,
        confirmButtonLabel: "Approve",
      });
    } else {
      setModalFields({
        ...modalFields,
        batch: batch,
        title: "Approve selected Users?",
        isOpen: true,
        decline: false,
        confirmButtonLabel: "Approve",
      });
    }
  };

  useEffect(() => {
    setModalFields({
      ...modalFields,
      body: (
        <RemarkBody
          text={modalFields.decline}
          errorMessage={errorMessage}
          setRemarks={setRemarks}
          batch={modalFields.batch}
        />
      ),
      onConfirm: () => {
        eightAxios
          .post(
            modalFields.batch
              ? modalFields.decline
                ? urls.batchDecline
                : urls.batchApprove
              : modalFields.decline
              ? urls.declineURL.replace("{id}", modalFields.id)
              : urls.approveURL.replace("{id}", modalFields.id),
            modalFields.batch
              ? {
                  ids: selected,
                  remarks: remarks,
                  filter_params: filterValues,
                }
              : {
                  remarks: remarks,
                  filter_params: filterValues,
                }
          )
          .then((response) => {
            let tempModalFields = modalFields;
            setSelected([]);
            setRefresh(true);
            setModalFields({});
            setModalFields({ ...tempModalFields, isOpen: false });
            setNotify({
              isOpen: true,
              message: response.data.message,
              type: "success",
            });
          })
          .catch((error) => {
            if(error.response){
              if(error.response.status === 400){
                setNotify({
                    isOpen: true,
                    message: "User approve failed. Please try again.",
                    type: "error",
                });
                setModalFields({
                  ...modalFields,
                  isOpen: false,
                });
              } else {
                let errMsg = "";
                for(let key in error.response.data){
                  errMsg += error.response.data[key] + "\n";
                }
                setErrorMessage(errMsg);
                setNotify({
                    isOpen: true,
                    message: "User approve failed. Please try again.",
                    type: "error",
                });
              }
            } else {
              setErrorMessage(error.message);
              setNotify({
                  isOpen: true,
                  message: "User approve failed. Please try again.",
                  type: "error",
              });
            }
          })
          .finally(() => {
            setRefresh(false);
          });
      },
    });
  }, [
    modalFields.id,
    modalFields.decline,
    modalFields.batch,
    errorMessage,
    remarks,
    selected,
  ]);

  const declineWorker = (id = null, batch = false) => {
    if (id) {
      setModalFields({
        ...modalFields,
        id: id,
        batch: batch,
        isOpen: true,
        decline: true,
        title: "Add Remark to decline this user",
        confirmButtonLabel: "Decline User",
      });
    } else {
      setModalFields({
        ...modalFields,
        id: id,
        batch: batch,
        isOpen: true,
        decline: true,
        title: "Add Remark to decline selected users",
        confirmButtonLabel: "Decline Users",
      });
    }
  };

  let module = getAssignedModule(location.pathname);
  let actionPermission = false;
  if (!module || module === "") {
    actionPermission = true;
  } else {
    let updatedModules = JSON.parse(
      localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
    );
    if (updatedModules[module]) {
      let modulePermissions = updatedModules[module].map((perm) => {
        if (typeof perm === "string") {
          return perm.toLowerCase();
        }
        return perm;
      });
      if (modulePermissions.includes("change status")) {
        actionPermission = true;
      }
    }
  }

  // const actions = [
  //   {
  //     type: "approve",
  //     title: "Approve",
  //     icon: <CheckCircleOutlineIcon style={{ color: "green" }} />,
  //     onClick: (id) => approveWorker(id),
  //   },
  //   {
  //     type: "decline",
  //     title: "Decline",
  //     icon: <BlockIcon color="primary" />,
  //     onClick: (id) => declineWorker(id),
  //   },
  // ];
  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  const clearFilter =()=>{
    filterInitialValues.status = null
    location.reload();
   }

  return (
    <div>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
        onClear={clearFilter}

      />
      <Table
        proxyURL={urls.proxyURL}
        model={model}
        // actions={actionPermission ? actions : null}
        excelExport={{ fileName: "Pending" }}
        filterValues={filterValues}
        noAddButton
        noFilter
        // linkUrlName="/view/"
        refresh={refresh}
        check
        actionBarButtons={actionPermission ? actionBarButtons : null}
        selected={selected}
        // callback setter
        setSelected={setSelected}
        pageNumberDropdown={pageNumberDropdown}

      />
      <Modal modalFields={modalFields} setModalFields={setModalFields} />
    </div>
  );
};

export default PendingApprovalList;
